import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {facultyCreateTt} from '../../redux/action/facultyAction'
import classnames from 'classnames';
import FacultyHomeHelper from '../../Components/FacultyHomeHelper';
import { useHistory,Link } from 'react-router-dom';

const FacultyCreateTimeTable = () => {
  const store = useSelector((store) => store);
  const dispatch = useDispatch();
  const [section, setSection] = useState('');
  const [semester, setSemester] = useState('');
  const [year, setYear] = useState('');
  const [timetableData, setTimetableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});
  const history = useHistory();

  const daysOfWeek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];

  const periods = [
    '1st Period  <small>(9:00 to 9:55)</small>',
    '2nd Period  <small>(9:55 to 10:50)</small>',
    '3rd Period  <small>(11:05 to 11:55)</small>',
    '4th Period  <small>(12:55 to 12:45)</small>',
    '5th Period  <small>(1:15 to 2:10)</small>',
    '6th Period  <small>(2:10 to 3:00)</small>',
    '7th Period  <small>(3:10 to 4:00)</small>',
    'Coaching  <small>(4:10 to 5:30)</small>',
  ];

  const createTimeTable = (timetableData) => {
    // Dispatch the data to the createTimeTable action
    dispatch(facultyCreateTt(timetableData));
  };

  const formHandler = (e) => {
    e.preventDefault();
    const timetableData = {
      year,
      department: store.faculty.faculty.faculty.department,
      section,
      semester,
      timetable: daysOfWeek.map((day, dayIndex) => ({
        day,
        periods: periods.map((period, periodIndex) => {
          const inputFieldName = `${day}-${periodIndex + 1}`;
          const inputValue = e.target[inputFieldName]?.value; // Using optional chaining to handle potential undefined
          return {
            periodName: `${periodIndex + 1}st Period`,
            content: inputValue,
          };
        }),
      })),
    };
      createTimeTable(timetableData);

  };


  return (
    <div>
      {store.faculty.isAuthenticated ? (
        <>
          <div className="container-fluid p-0">
            <div className="d-flex">
              <div className="print-helper">
                <FacultyHomeHelper />
              </div>
              <div className="mx-1 w-100 ">
                <div className='px-3 py-1 bg-light d-flex align-items-center justify-content-between'>
                <h5><Link to='/FacultyTimeTable' className='text-light'><img src="/image/Back.svg" className='p-2' alt="" /></Link></h5>

                  <h3> <img src="/logo192.png" width={'50px'} alt="" /> Time Table</h3>
                  <button onClick={()=> window.print()} type="button" className=" btn-success btn text-light"> <img src="/image/print.svg" lt="" /> Download</button>
                </div>
                <div className="col d-md-flex align-items-center justify-content-between">
                            <form form-inline  noValidate onSubmit={formHandler}>
                              <div className='d-md-flex align-items-center justify-content-start'>
                                <h5 className='m-3'>Department: {store.faculty.faculty.faculty.department} </h5>
                                <div className="form-group mx-2 print-helper">
                                      <label htmlFor="yearId">Year</label>
                                      <select onChange={(e) => setYear(e.target.value)} className={classnames("form-control",
                                          {
                                              'is-invalid': error.year
                                          })} id="yearId">
                                          <option>Select</option>
                                          <option value="I">1</option>
                                          <option value="II">2</option>
                                          <option value="III">3</option>
                                          <option value="IV">4</option>
                                      </select>
                                      {error.year && (<div className="invalid-feedback">{error.year}</div>)}
                                </div>
                                <div className="form-group mx-2 print-helper">
                                  <label htmlFor="sectionId">Section</label>
                                  <select
                                    onChange={(e) => {
                                        setSection(e.target.value);
                                    }}
                                    className={classnames("form-control", { 'is-invalid': error.section })}
                                    id="sectionId"
                                  >
                                    <option>Select</option>
                                    <option value="A">A</option>
                                    <option value="B">B</option>
                                    <option value="C">C</option>
                                    <option value="D">D</option>
                                  </select>
                                  {error.section && (<div className="invalid-feedback">{error.section}</div>)}
                                </div>
                                <div className="form-group mx-2 print-helper">
                                  <label htmlFor="semesterId">Semester</label>
                                  <select
                                    onChange={(e) => {
                                        setSemester(e.target.value);
                                    }}
                                    className={classnames("form-control", { 'is-invalid': error.semester })}
                                    id="semesterId"
                                  >
                                    <option>Select</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                  </select>
                                  {error.section && (<div className="invalid-feedback">{error.section}</div>)}
                                </div>
                              </div>
                      <div className="col m-auto">
                          <div>
                            <div className="resultT p-2">
                              <h2 className="text-center">TimeTable</h2>
                              <div className="d-flex w-100 justify-content-around mt-3">
                                <h5>Department : {store.faculty.faculty.faculty.department} </h5>
                                <h5>Year : {year} </h5>
                                <h5>Semester : {semester} </h5>
                                <h5>Section : {section} </h5>
                              </div>
                            </div>
                            <table className="table resultT p-2 table-responsive table-striped table-bordered">
                              <thead>
                                <tr className="table resultTcol text-light">
                                  <th width="10%">Day</th>
                                  {periods.map((period, index) => (
                                    <th width="10%" key={index}>
                                      <span dangerouslySetInnerHTML={{ __html: period }} />
                                    </th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {daysOfWeek.map((day, dayIndex) => (
                                  <tr key={dayIndex}>
                                    <td>{day}</td>
                                    {periods.map((period, periodIndex) => {
                                      const timetableEntry = timetableData.find(
                                        (entry) =>
                                          entry.day === day &&
                                          entry.periods[periodIndex].periodName === `${periodIndex + 1}st Period`
                                      );
                                      return (
                                        <td key={periodIndex}>
                                          <input
                                            className="form-control form-control-sm"
                                            type="text"
                                            name={`${day}-${periodIndex + 1}`} // Use a unique identifier for each input field
                                          />
                                        </td>
                                      );
                                    })}
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                  </div>
                  <button  type="submit" className=" btn-success btn text-light m-2" > <img src="/image/add.svg" lt="" /> Upload TimeTable</button>

                          </form>
                      </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        history.push('/')
      )}
    </div>
  );
};

export default FacultyCreateTimeTable;
